export default __webpack_public_path__ + "static/media/cpa_gold_black_logo.41f00279.png";